import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaComments, FaVideo, FaMars, FaVenus, FaRandom } from "react-icons/fa";
import "./ModeSelection.css";
export default function ModeSelection() {
  const navigate = useNavigate();
  const [selectedMode, setSelectedMode] = useState(null); // 'text' or 'video'

  const handleModeChoice = (mode) => {
    setSelectedMode(mode);
  };

  const handleGenderChoice = (gender) => {
    // Navigate to appropriate lobby with gender preference
    if (selectedMode === 'text') {
      navigate("/funtellime/text-lobby", { state: { genderPreference: gender } });
    } else if (selectedMode === 'video') {
      navigate("/funtellime/video-lobby", { state: { genderPreference: gender } });
    }
  };

  const handleBack = () => {
    if (selectedMode) {
      setSelectedMode(null); // Go back to mode selection
    } else {
      navigate("/dashboard"); // Go to dashboard
    }
  };
  return (
    <div className="mode-selection-container">
      <div className="mode-selection-content">
        {!selectedMode ? (
          // Step 1: Mode Selection
          <>
            <h1 className="mode-selection-title">Choose Your Mode</h1>
            <p className="mode-selection-subtitle">How would you like to connect?</p>
            <div className="mode-cards">
              {/* Text Chat Card */}
              <div className="mode-card" onClick={() => handleModeChoice('text')}>
                <div className="mode-icon"><FaComments /></div>
                <h2>Text Chat</h2>
                <p>Connect through messages</p>
                <p className="mode-description">
                  Text-based conversations with matched partners based on shared interests
                </p>
                <button className="mode-btn text-btn">Start Text Chat</button>
              </div>
              {/* Video Chat Card */}
              <div className="mode-card" onClick={() => handleModeChoice('video')}>
                <div className="mode-icon"><FaVideo /></div>
                <h2>Video Chat</h2>
                <p>Face-to-face connection</p>
                <p className="mode-description">
                  Real-time video conversations with emotional intelligence coaching
                </p>
                <button className="mode-btn video-btn">Start Video Chat</button>
              </div>
            </div>
          </>
        ) : (
          // Step 2: Gender Preference Selection
          <>
            <h1 className="mode-selection-title">Who would you like to meet?</h1>
            <p className="mode-selection-subtitle">Choose your match preference</p>
            <div className="gender-cards">
              {/* Male Card */}
              <div className="gender-card" onClick={() => handleGenderChoice('male')}>
                <div className="gender-icon male-icon"><FaMars /></div>
                <h2>Male</h2>
                <p>Connect with male users</p>
              </div>
              {/* Female Card */}
              <div className="gender-card" onClick={() => handleGenderChoice('female')}>
                <div className="gender-icon female-icon"><FaVenus /></div>
                <h2>Female</h2>
                <p>Connect with female users</p>
              </div>
              {/* Random Card */}
              <div className="gender-card" onClick={() => handleGenderChoice('random')}>
                <div className="gender-icon random-icon"><FaRandom /></div>
                <h2>Random</h2>
                <p>Connect with anyone</p>
              </div>
            </div>
          </>
        )}
        <button className="back-btn" onClick={handleBack}>
          ← Back {selectedMode ? 'to Mode Selection' : 'to Dashboard'}
        </button>
      </div>
    </div>
  );
}
